import { useAsync } from 'react-use';
import { HotelContentApi } from '@model/iceberg/service/hotel-content/hotel-content-api';
import { GenericComponent } from '@model/content';
import { Component as ComponentContainer } from '@styles/layout';
import { ProductPackageGroup } from '@components/product/product-package/ProductPackageGroup';

export const PopularHotelsContainer = ({ path, data, destination }: GenericComponent) => {
  if (!path) {
    return null;
  }
  const { value: hotels } = useAsync(async () => {
    return data ? data : await new HotelContentApi().tiles([path], 5);
  }, [path]);

  return hotels?.data && destination ? (
    <ComponentContainer>
      <ProductPackageGroup path={path} packages={hotels?.data} destination={destination?.display} />
    </ComponentContainer>
  ) : null;
};
